import { render, staticRenderFns } from "./Singo.vue?vue&type=template&id=2220b1da&scoped=true&"
import script from "./Singo.vue?vue&type=script&lang=js&"
export * from "./Singo.vue?vue&type=script&lang=js&"
import style0 from "./Singo.vue?vue&type=style&index=0&id=2220b1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220b1da",
  null
  
)

export default component.exports